import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { recurlyMopTypeToPaymentMethods } from '../constants/PaymentTypes';

/**
 * converts Recurly MopDetails data response to PaymentMethodsData so
 * the response can be properly stored in Redux
 * @param props MopDetails
 * @returns PaymentMethodsData
 */

export var transformRecurlyMopDetailsToPaymentMethodsData = function transformRecurlyMopDetailsToPaymentMethodsData(props) {
  var id = props.id,
    mopHolderName = props.mopHolderName,
    mopInfo = props.mopInfo,
    billingAddress = props.billingAddress,
    valid = props.valid,
    isPrimary = props.isPrimary,
    isBackup = props.isBackup;
  var _mopHolderName$split = mopHolderName.split(' '),
    _mopHolderName$split2 = _slicedToArray(_mopHolderName$split, 2),
    firstName = _mopHolderName$split2[0],
    lastName = _mopHolderName$split2[1];
  var cardInfo = mopInfo.card;
  var month = cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.expMonth.toString().padStart(2, '0');
  var year = cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.expYear;
  var last4 = cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.last4;
  var accountType = mopInfo.type; // ex. CREDIT_CARD

  var cardType = cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.cardType; // ex. VISA
  var description = '';
  if (month && year) {
    description = "*".concat(last4, " - Exp. ").concat(month, "/").concat(year % 100, " - ").concat(mopHolderName);
  } else {
    description = "".concat(mopHolderName);
  }
  var formattedBillingAddress = {
    line1: billingAddress.addressLine1,
    line2: billingAddress.addressLine2,
    city: billingAddress.city,
    state: billingAddress.state,
    country: billingAddress.country,
    fname: mopInfo.type === 'VENMO' ? mopInfo.venmo.username : firstName,
    lname: lastName,
    phone: billingAddress.phone,
    zip: billingAddress.postalCode
  };
  return {
    active: valid,
    canDisable: true,
    canUpdate: false,
    // Recurly does not support edit PM currently
    cardId: id,
    cardIdHash: id,
    accountType: recurlyMopTypeToPaymentMethods.get(accountType),
    type: cardType && recurlyMopTypeToPaymentMethods.get(cardType) || cardType,
    description: description,
    last4: last4,
    month: month,
    year: year === null || year === void 0 ? void 0 : year.toString(),
    billingAddress: formattedBillingAddress,
    isRecurly: true,
    isBackup: isBackup,
    isPrimary: isPrimary
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/utils/TransformUtils.js
// module id = 899
// module chunks = 11